export const findIsolatedNodes = (nodes, edges) => {
  if (edges.length === 0) {
    return nodes.map(n => n.id);
  }
  const connectedNodeIds = new Set();
  edges.forEach(edge => {
    connectedNodeIds.add(edge.source);
    connectedNodeIds.add(edge.target);
  });

  const isolatedNodeIds = nodes
    .filter(node => !connectedNodeIds.has(node.id))
    .map(node => node.id);

  return isolatedNodeIds;
};

export const findCycles = (nodes, edges) => {
  const adj = new Map();
  nodes.forEach(node => adj.set(node.id, []));
  edges.forEach(edge => {
    if (adj.has(edge.source)) {
      adj.get(edge.source).push(edge.target);
    }
  });

  const cycles = [];
  const path = [];
  const visited = new Set();
  const recursionStack = new Set();

  function detectCycle(nodeId) {
    visited.add(nodeId);
    recursionStack.add(nodeId);
    path.push(nodeId);

    const neighbors = adj.get(nodeId) || [];
    for (const neighborId of neighbors) {
      if (recursionStack.has(neighborId)) {
        const cycleStartIndex = path.indexOf(neighborId);
        const cycle = path.slice(cycleStartIndex);
        cycles.push(cycle);
      } else if (!visited.has(neighborId)) {
        detectCycle(neighborId);
      }
    }

    path.pop();
    recursionStack.delete(nodeId);
  }

  for (const node of nodes) {
    if (!visited.has(node.id)) {
        detectCycle(node.id);
    }
  }

  const uniqueCycles = [];
  cycles.forEach(cycle => {
      const sortedCycle = [...cycle].sort().join(',');
      if (!uniqueCycles.some(c => [...c].sort().join(',') === sortedCycle)) {
          uniqueCycles.push(cycle);
      }
  });


  return uniqueCycles;
};

export const findEmptyNodes = (nodes) => {
  return nodes
    .filter(node => !node.data?.label || node.data.label.trim() === '')
    .map(node => node.id);
};
